
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AssessmentHeader from "./AssessmentHeader.vue";
import QuestionComponent from "./QuestionComponent.vue";

import {
  ViewAssessmentsOptions,
  CandidateAiAssessmentsViewOptions,
  AssessmentResultStatus,
  AppEnglish3McqsAnswers,
  AssessmentData,
  AssessmentQuestion
} from "@/interfaces/candidate/canidate_assessments";
import InterviewLoading from "@/components/candidate/interviews/InterviewLoading.vue";
import {
  AssessmentChat,
  AssessmentChatRoles,
  SubmitAssessmentAnswersApiPayload,
  SubmitAssessmentMcqsAnswersApiPayload,
  UpdateAssessmentQuestionPayload,
  UpdateAssessmentMcqsPayload
} from "@/store/modules/candidates/interfaces";
import {
  APP_ASSESSMENT_SS,
  APP_AI_ASSESSMENT_CANCELLED,
  APP_AI_ASSESSMENT_COMPLETED,
  APP_AI_CURRENT_QUESTION_INDEX,
  ASSESSMENT_AVERAGE_TIME_STATS,
  ASSESSMENT_QUESTIONNAIRES,
  ASSESSMENT_QUESTIONNAIRES_AI,
  ASSESSMENT_QUESTIONNAIRES_AI_UPDATE,
  CAMERA_RECORDING_SUPPORTED,
  SCREEN_RECORDING_SUPPORTED,
  SUBMIT_APP_ASSESSMENT_ANSWERS,
  SUBMIT_APP_ASSESSMENT_ANSWER_MEDIA,
  SUBMIT_APP_ASSESSMENT_MEDIA
} from "@/store/modules/candidates/constants";
import { generate_random_key, wait_until } from "@/utils/global";
import moment from "moment";
import {
  GET_USER_DETAILS,
  GET_COMPANY_DETAILS
} from "@/store/modules/auth/constants";
import {
  APP_ASSESSMENTS,
  SITE_DIRECTION,
  UPLOAD_FILE_CHUNK,
  MARK_ASSESSMENT_RESUMED,
  SAVE_ASSESSMENT_STATE
} from "@/store/modules/common/constants";
import {
  FETCH_APPLICANT_ASSESSMENT_DETAILS,
  APPLICANT_ASSESSMENT_DETAILS
} from "@/store/modules/recruiter/constants";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import AccessDeniedComponent from "@/components/candidate/app_assessments/AccessDeniedComponent.vue";
import AppResourseNotFound from "@/components/candidate/app_assessments/AppResourseNotFound.vue";
import { SiteDirections } from "@/store/modules/common/interfaces";
import ProgressUploader from "@/components/shared/ProgressUploader.vue";
import { AssessmentRecordType } from "@/interfaces/app.interface";
import { get_random_number_between } from "@/utils/global";
import {
  isIOS,
  isSafari,
  getMediaRecorderMimeTypes,
  getRecordingMimeTypeAndExt
} from "@/utils/browser.utils";
import socketService from "@/services/socket.service";
export default Vue.extend({
  name: "AppAiAssessmentRoot",
  components: {
    AssessmentHeader,
    QuestionComponent,
    InterviewLoading,
    AccessDeniedComponent,
    AppResourseNotFound,
    ProgressUploader
  },
  data() {
    return {
      // New assessment data structure
      assessmentData: null as AssessmentData | null,
      assessmentCompleted: false,
      assessmentCancelled: false,
      currentQuestionIndex: 0, // This will be the index in the overall questions array
      totalAssessmentTime: 0, // Total time for all questions
      submittingAnswer: false,
      // Track all answered questions
      answeredQuestions: [] as Array<{
        questionId: number;
        answer: string;
        questionType: CandidateAiAssessmentsViewOptions;
        timestamp: Date;
      }>,

      // Legacy data (to be removed gradually)
      mcqs_part1_completed: false,
      assessmentTime: 0, //time spend on assessmenty
      partTime: 0, //time spend on part
      questionTime: 0, //time spend on question
      canSelect: true,
      selected_question: "",
      speaking_questions: [] as string[],
      assessment_type: "",
      stage: "",
      answeredMcqsCount: 0,
      disabled_next_question: true as boolean, // To disable next button
      options: [] as AppEnglish3McqsAnswers[],
      error: "" as string, // Global error message
      loading: false as boolean, // Global loading
      isOffline: false as boolean,
      connectionCheckIntervalId: null as ReturnType<typeof setInterval> | null,
      media_stopped: false as boolean,
      screen_recroding_start_time: new Date(), // For screen recording start time
      screen_recroding_end_time: new Date(), // For screen recording end time
      camera_recording_start_time: new Date(), // For camera recording start time
      camera_recording_end_time: new Date(), // For camera recording end time
      // For screen recording
      media_stream: null as MediaStream | null, // For screen recording stream
      media_enabled: false as boolean, // To check if screen recording is enabled or not
      screen_recorder: null as MediaRecorder | null, // For screen recording
      screen_recoding_chunks: [] as Blob[], // For screen recording chunks
      // For camera/audio recording
      camera_media_stream: null as MediaStream | null, // For camera stream
      camera_media_recorder: null as MediaRecorder | null, // For camera recording
      camera_media_enabled: false as boolean, // To check if camera is enabled or not
      camera_recorded_blobs: [] as Blob[], // For camera recording chunks
      transcript: "" as string, // User speech transcript
      // eslint-disable-next-line no-undef
      speech_recognition: null as typeof window.webkitSpeechRecognition | null,
      speech_mode: false as boolean, // To check if speech mode is enabled or not
      bot_speaking: true as boolean, // To check if bot is speaking or not
      speaking_history: [] as AssessmentChat[], // To store user speech history
      bot_image: require("@/assets/images/female-bot.png"),
      bot_ans_loading: false as boolean, // To check if bot is answering or not
      submit_ans_loading: false as boolean, // To check if user answer is submitting or no
      // For audio recording
      audio_recorder: null as MediaRecorder | null, // For audio recording
      audio_recorder_chunks: [] as Blob[], // For audio recording chunks
      user_ans_recorder_chunks: [] as Blob[], // For user individual answer recording chunks
      individual_ans_blob: null as Blob | null, // For individual answer blob
      // For Uploading camera/media recording files
      media_uploading: false, // To check if media uploading is in progress or not
      media_uploading_title: "", // Media uploading title
      media_uploading_progress: 0, // Media uploading progress
      ttsAudio: null as HTMLAudioElement | null, // Audio Object
      screen_recording_upload_chuk_size: 6 * 1024 * 1024,
      camera_recording_upload_chuk_size: 6 * 1024 * 1024,
      recording: false,
      startTime: 0,
      elapsedTime: "0:0",
      totalPausedTime: 0,
      paused: false,
      pauseStartTime: 0,
      audio_media_stream: null as MediaStream | null, // For camera stream,
      ai_assessment_time: 1800,
      ai_assessment_timer: 0,
      dialog: true,
      is_reload: false,
      disabled_mcqs1_question: true,
      timers: {} as Record<string, ReturnType<typeof setInterval>> // Store multiple timer IDs
    };
  },
  computed: {
    ViewAssessmentsOptions() {
      return ViewAssessmentsOptions;
    },
    CandidateAiAssessmentsViewOptions() {
      return CandidateAiAssessmentsViewOptions;
    },
    AssessmentResultStatus() {
      return AssessmentResultStatus;
    },
    AssessmentChatRoles() {
      return AssessmentChatRoles;
    },
    // New computed properties - simplified approach
    allQuestions(): AssessmentQuestion[] {
      return this.assessmentData?.questions || [];
    },
    currentQuestion(): AssessmentQuestion | null {
      return this.allQuestions[this.currentQuestionIndex] || null;
    },
    currentQuestionType(): CandidateAiAssessmentsViewOptions {
      return (
        (this.currentQuestion
          ?.question_type as CandidateAiAssessmentsViewOptions) ||
        CandidateAiAssessmentsViewOptions.MULTIPLE_CHOICE
      );
    },
    filteredQuestions(): AssessmentQuestion[] {
      // Return questions of the same type as current question for header display
      const currentType = this.currentQuestionType;
      return this.allQuestions.filter((q) => q.question_type === currentType);
    },
    isLastQuestion(): boolean {
      return this.currentQuestionIndex >= this.allQuestions.length - 1;
    },
    progressPercentage(): number {
      if (this.allQuestions.length === 0) return 0;
      return ((this.currentQuestionIndex + 1) / this.allQuestions.length) * 100;
    },
    isCurrentQuestionAnswered(): boolean {
      const currentQuestion = this.currentQuestion;
      if (!currentQuestion) return false;
      return this.answeredQuestions.some(
        (aq) => aq.questionId === currentQuestion.id
      );
    },
    currentAnswer(): string {
      const currentQuestion = this.currentQuestion;
      if (!currentQuestion) return "";
      const answered = this.answeredQuestions.find(
        (aq) => aq.questionId === currentQuestion.id
      );
      return answered ? answered.answer : "";
    },
    // Calculate total time for all questions
    totalTimeForAllQuestions(): number {
      if (!this.assessmentData?.questions) return 0;
      return this.assessmentData.questions.reduce((total, question) => {
        return total + (question.question_time_allowed || 0);
      }, 0);
    },
    ...mapGetters("candidate", {
      app_ai_assessment: ASSESSMENT_QUESTIONNAIRES_AI,
      current_question_index: APP_AI_CURRENT_QUESTION_INDEX,
      assessment_completed: APP_AI_ASSESSMENT_COMPLETED,
      assessment_ss: APP_ASSESSMENT_SS,
      get_camera_recording_supported: CAMERA_RECORDING_SUPPORTED,
      get_screen_recording_supported: SCREEN_RECORDING_SUPPORTED,
      get_store_data: ASSESSMENT_QUESTIONNAIRES_AI_UPDATE
    }),
    ...mapGetters("auth", {
      get_user: GET_USER_DETAILS,
      get_company_details: GET_COMPANY_DETAILS
    }),
    ...mapGetters("common", {
      app_assessments: APP_ASSESSMENTS,
      get_site_direction: SITE_DIRECTION
    }),
    ...mapGetters("recruiter", {
      ai_assessment_details: APPLICANT_ASSESSMENT_DETAILS
    }),
    SiteDirections() {
      return SiteDirections;
    },
    // Computed properties for complex template expressions
    speakingInstructionAr() {
      return this.app_ai_assessment &&
        this.app_ai_assessment.speaking &&
        this.app_ai_assessment.speaking[0] &&
        this.app_ai_assessment.speaking[0].question_options
        ? this.app_ai_assessment.speaking[0].question_options.instructionar
        : "";
    },
    speakingInstructionEng() {
      return this.app_ai_assessment &&
        this.app_ai_assessment.speaking &&
        this.app_ai_assessment.speaking[0] &&
        this.app_ai_assessment.speaking[0].question_options
        ? this.app_ai_assessment.speaking[0].question_options.instructioneng
        : "";
    },
    speakingVideoSrc() {
      return this.app_ai_assessment &&
        this.app_ai_assessment.speaking &&
        this.app_ai_assessment.speaking[1] &&
        this.app_ai_assessment.speaking[1].question_options &&
        this.app_ai_assessment.speaking[1].question_options.bot
        ? this.app_ai_assessment.speaking[1].question_options.bot.en
        : "";
    },
    currentSpeakingVideoSrc() {
      return this.app_ai_assessment &&
        this.app_ai_assessment.speaking &&
        this.app_ai_assessment.speaking[this.current_question_index] &&
        this.app_ai_assessment.speaking[this.current_question_index]
          .question_options &&
        this.app_ai_assessment.speaking[this.current_question_index]
          .question_options.bot
        ? this.app_ai_assessment.speaking[this.current_question_index]
            .question_options.bot.en
        : "";
    },
    currentSpeakingTimeAllowed() {
      return this.app_ai_assessment &&
        this.app_ai_assessment.speaking &&
        this.app_ai_assessment.speaking[this.current_question_index]
        ? this.app_ai_assessment.speaking[this.current_question_index]
            .question_time_allowed
        : 60;
    },
    speakingLength() {
      return this.app_ai_assessment?.speaking?.length || 1;
    },
    mcqsLength() {
      return this.app_ai_assessment?.mcqs?.length || 1;
    },
    mcqsArray() {
      return this.app_ai_assessment?.mcqs || [];
    },
    currentMcqTimeAllowed() {
      return this.app_ai_assessment &&
        this.app_ai_assessment?.mcqs &&
        this.app_ai_assessment.mcqs[this.current_question_index]
        ? this.app_ai_assessment.mcqs[this.current_question_index]
            .question_time_allowed
        : 60;
    }
  },
  created() {
    // Random number between 8-15
    const screen_random_number = get_random_number_between(8, 15);
    const camera_random_number = get_random_number_between(8, 15);
    this.screen_recording_upload_chuk_size = screen_random_number * 1024 * 1024;
    this.camera_recording_upload_chuk_size = camera_random_number * 1024 * 1024;
    // Add the event listener when the component is created so assessments cannot silently continue in a background tab
    if (typeof document !== "undefined") {
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
  },
  async mounted() {
    window.addEventListener("offline", this.handleOffline);
    window.addEventListener("online", this.handleOnline);
    this.isOffline = !navigator.onLine;
    // Periodic check (browser "offline" event is unreliable on some systems)
    this.connectionCheckIntervalId = setInterval(() => {
      if (this.assessmentCompleted) return;
      const offline = !navigator.onLine;
      if (offline !== this.isOffline) {
        this.isOffline = offline;
        if (offline) {
          this.set_root_error(
            this.$t("assessments.internet-disconnected").toString()
          );
        }
      }
    }, 2000);

    // Load assessment data using new API structure
    await this.loadAssessmentData();
    // Only initialize camera and screen recording if assessment is not completed
    if (!this.assessmentCompleted) {
      this.init_process();

      // Start timers only for active assessments
      let new_ass_time = Number(localStorage.getItem("aiAssessmentTimer")) || 0;
      this.ai_assessment_time = this.ai_assessment_time - new_ass_time;
      this.startTimer("ai_assessment_timer");
    }
  },

  methods: {
    generate_random_key,
    // New methods for assessment handling
    switchQuestionType(questionType: CandidateAiAssessmentsViewOptions) {
      if (this.isOffline) return;
      // Find the first question of this type
      const firstQuestionOfType = this.allQuestions.findIndex(
        (q) => q.question_type === questionType
      );
      if (firstQuestionOfType >= 0) {
        this.currentQuestionIndex = firstQuestionOfType;
      }
    },
    async handleAnswerSubmission(answerData: any) {
      if (this.isOffline) {
        this.set_root_error(
          this.$t("assessments.reconnect-to-continue").toString()
        );
        return;
      }
      try {
        this.submittingAnswer = true;

        await this.fetchAiAssessmentData();

        // Store the answer locally
        const answerRecord = {
          questionId: answerData.questionId,
          answer: answerData.answer,
          questionType: answerData.questionType,
          timestamp: new Date()
        };

        // Check if this question was already answered
        const existingAnswerIndex = this.answeredQuestions.findIndex(
          (aq) => aq.questionId === answerData.questionId
        );

        if (existingAnswerIndex >= 0) {
          // Update existing answer
          this.answeredQuestions[existingAnswerIndex] = answerRecord;
        } else {
          // Add new answer
          this.answeredQuestions.push(answerRecord);
        }
        // Process next question (submit individual answer)
        await this.process_next_question(answerRecord);
      } catch (error) {
        console.error("Error handling answer submission:", error);
        this.set_root_error(
          this.$t("ai-assessments.errors.submit-failed").toString()
        );
      } finally {
        this.submittingAnswer = false;
      }
    },
    previousQuestion() {
      if (this.isOffline) return;
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    },
    // Persist current state to backend for resume capability
    async persistCurrentState() {
      try {
        const assessmentId = Number(this.$route.params.id);
        if (!assessmentId) return;

        const state = {
          currentQuestionIndex: this.currentQuestionIndex,
          aiAssessmentTimer: this.ai_assessment_timer,
          timestamp: new Date().toISOString()
        };

        await this.save_assessment_state({
          assessment_id: assessmentId,
          saved_state: state
        });
      } catch (error) {
        console.error("Error persisting assessment state:", error);
      }
    },
    // Process next question and set current question to next question if exist
    async process_next_question(answerRecord: any) {
      localStorage.setItem("current_question", this.currentQuestionIndex + 1);
      let payload = {};
      this.submit_ans_loading = true; // Set submit answer loading
      const is_last_question =
        this.currentQuestionIndex < this.allQuestions.length - 1 ? false : true;
      if (!this.currentQuestion) return; // If current question not exist then return

      // API Call to save current question answer
      const api_payload: SubmitAssessmentAnswersApiPayload = {
        answer: answerRecord.answer,
        question_id: answerRecord.questionId,
        answer_type: answerRecord.questionType,
        assessment_id:
          this.assessmentData?.assessment?.id || this.$route.params.id,
        done: is_last_question,
        current_question_index: this.currentQuestionIndex
      };

      // Set done to true if current question index is last question index
      if (this.currentQuestionIndex === this.allQuestions.length - 1) {
        api_payload.done = true;
        localStorage.removeItem("current_question");
      }

      const response = await this.submit_assessment_answers(api_payload);

      // Persist state to backend after each answer
      await this.persistCurrentState();

      // If response not exist then set root error and return
      if (!response) {
        this.set_root_error(`${this.$t("assessments.went-wrong")}`);
        this.submit_ans_loading = false; // Set submit answer loading
        return;
      }

      // Set time tracking payload
      payload = {
        [`${this.currentQuestion?.question_type}_time`]:
          this.questionTime.toString()
      };
      this.questionTime = 0;

      // If current question index is less than total questions length then set current question to next question
      if (this.currentQuestionIndex < this.allQuestions.length - 1) {
        this.currentQuestionIndex++; // Move to next question
      } else {
        // Last question - prepare for assessment completion
        payload = {
          ...payload,
          ai_assessment_time: this.ai_assessment_timer.toString(),
          answer_time: this.questionTime.toString(),
          done: true
        };
        this.questionTime = 0;
        this.ai_assessment_timer = 0;
        await this.process_assessment_completed();
      }

      this.set_assessment_average_time(payload);
      this.submit_ans_loading = false; // Set submit answer loading
    },
    // Function to process assessment completion event
    // Upload screen recording and camera recording to server
    // Navigate to dashboard
    async process_assessment_completed() {
      try {
        // Stop camera and all media first so the app releases the device immediately
        this.stopAllMediaStreams();

        // Mark assessment as completed in the store
        await this.fetchAiAssessmentData();

        // Upload recording chunks
        await this.upload_recording_chunks(AssessmentRecordType.SCREEN);
        await this.upload_recording_chunks(AssessmentRecordType.CAMERA);
        // Clear localStorage
        localStorage.removeItem("questionTime");
        localStorage.removeItem("partTime");
        localStorage.removeItem("assessmentTime");
        localStorage.removeItem("aiAssessmentTimer");
        localStorage.removeItem("current_question");

        // Mark assessment as completed
        this.assessmentCompleted = true;
      } catch (error) {
        console.error("Error processing assessment completion:", error);
        this.set_root_error(
          this.$t("ai-assessments.errors.complete-failed").toString()
        );
        // Ensure camera is still stopped even when completion steps fail
        this.stopAllMediaStreams();
      }
    },
    async submitCompleteAssessment() {
      // This method is now handled by process_assessment_completed
      // Keep for backward compatibility but redirect to the new method
      await this.process_assessment_completed();
    },
    async restoreCompletedQuestions() {
      try {
        // Clear existing answered questions
        this.answeredQuestions = [];
        // Restore questions based on is_completed status from API
        this.assessmentData.questions.forEach((question: any) => {
          if (question.is_completed) {
            // Restore actual answer from API
            this.answeredQuestions.push({
              questionId: question.id,
              questionType: question.question_type,
              answer: question.answer || "",
              timestamp: new Date()
            });
          }
        });
      } catch (error) {
        console.error("Error restoring completed questions:", error);
      }
    },
    goToDashboard() {
      // Ensure all media/recording is stopped before navigating away
      try {
        this.stopAllMediaStreams();
      } catch (e) {
        // ignore
      }
      this.$router.push("/candidate/dashboard");
    },
    async loadAssessmentData() {
      try {
        this.loading = true;
        const assessmentId = this.$route.params.id;
        const applicantId = this.get_user?.id;

        if (!assessmentId || !applicantId) {
          this.set_root_error(
            this.$t("ai-assessments.errors.no-id").toString()
          );
          return;
        }

        const success = await this.fetch_ai_assessment_details({
          applicant_id: applicantId.toString(),
          assessment_id: assessmentId.toString()
        });

        if (!success) {
          this.set_root_error(
            this.$t("ai-assessments.errors.load-failed").toString()
          );
          return;
        }

        // Transform the API data to match the new structure
        const apiResponse = this.ai_assessment_details as any;
        if (apiResponse) {
          this.assessmentData = apiResponse;

          // Check assessment result status
          const result = this.assessmentData.results?.[0];
          if (result) {
            switch (result.status) {
              case AssessmentResultStatus.COMPLETED:
                this.assessmentCompleted = true;
                break;
              case AssessmentResultStatus.CANCELLED:
                this.set_root_error(
                  this.$t("ai-assessments.errors.cancelled").toString()
                );
                this.$router.push("/candidate/ai-assessments");
                return;
              case AssessmentResultStatus.IN_PROGRESS: {
                // Resume from current question if available (1-indexed from backend usually)
                if (result.current_question && result.current_question > 0) {
                  this.currentQuestionIndex = result.current_question;
                }

                // Check localStorage for current_question (index + 1)
                const storedQuestion = localStorage.getItem("current_question");
                if (storedQuestion) {
                  this.currentQuestionIndex = parseInt(storedQuestion);
                }

                // Restore from saved_state (backend-side persistence)
                if (result.result_data?.saved_state) {
                  const savedState = result.result_data.saved_state;

                  // Restore timer if available
                  if (typeof savedState.aiAssessmentTimer === "number") {
                    this.ai_assessment_timer = savedState.aiAssessmentTimer;
                    // Also update localStorage for immediate consistency
                    localStorage.setItem(
                      "aiAssessmentTimer",
                      this.ai_assessment_timer.toString()
                    );
                  }

                  // Restore current question index if available and valid
                  if (
                    typeof savedState.currentQuestionIndex === "number" &&
                    savedState.currentQuestionIndex >= 0 &&
                    savedState.currentQuestionIndex <
                      this.assessmentData.questions.length
                  ) {
                    // If we have savedState, we prefer it as the most reliable source
                    this.currentQuestionIndex = savedState.currentQuestionIndex;
                  }
                }
                break;
              }
              case AssessmentResultStatus.RESULT_PROCESSING:
                this.assessmentCompleted = true;
                break;
              case AssessmentResultStatus.FAILED:
                this.set_root_error(
                  this.$t("ai-assessments.errors.failed-complete").toString()
                );
                break;
              case AssessmentResultStatus.REDO:
                this.set_root_error(
                  this.$t("ai-assessments.errors.needs-redo").toString()
                );
                break;
              default:
                break;
            }
          }

          // Restore completed questions and set current question index
          if (this.assessmentData.questions.length > 0) {
            // Find the first incomplete question
            const incompleteQuestionIndex =
              this.assessmentData.questions.findIndex(
                (question: any) => !question.is_completed
              );

            // Only use incompleteQuestionIndex if currentQuestionIndex hasn't been set by resume logic already
            if (this.currentQuestionIndex === 0) {
              if (incompleteQuestionIndex !== -1) {
                // Set current question to the first incomplete question so user can resume
                this.currentQuestionIndex = incompleteQuestionIndex;
              } else {
                // All questions are completed
                this.currentQuestionIndex =
                  this.assessmentData.questions.length - 1;
              }
            }

            // Set the active question type based on current question
            const currentQuestion =
              this.assessmentData.questions[this.currentQuestionIndex];
            if (currentQuestion) {
              this.activeQuestionType = currentQuestion.question_type;
            }

            // Restore answered questions based on is_completed status
            this.restoreCompletedQuestions();
          }
        } else {
          console.error("No valid assessment data received:", apiResponse);
          this.set_root_error(
            this.$t("ai-assessments.errors.no-questions").toString()
          );
        }
      } catch (error) {
        console.error("Error loading assessment data:", error);
        this.set_root_error(
          this.$t("ai-assessments.errors.load-error").toString()
        );
      } finally {
        this.loading = false;
      }
    },
    ...mapMutations("candidate", {
      set_app_ai_assessments: ASSESSMENT_QUESTIONNAIRES_AI,
      update_app_ai_assessment_questions: ASSESSMENT_QUESTIONNAIRES_AI_UPDATE,
      increment_question_index: APP_AI_CURRENT_QUESTION_INDEX,
      set_screen_recording_supported: SCREEN_RECORDING_SUPPORTED,
      set_camera_recording_supported: CAMERA_RECORDING_SUPPORTED
    }),
    ...mapMutations({
      set_root_error: ROOT_ERROR,
      set_root_notification: ROOT_NOTIFICATION
    }),
    ...mapActions("candidate", {
      fetch_assessment_questionnaries: ASSESSMENT_QUESTIONNAIRES,
      submit_assessment_answers: SUBMIT_APP_ASSESSMENT_ANSWERS,
      submit_assessment_media: SUBMIT_APP_ASSESSMENT_MEDIA,
      submit_assessment_ans_media: SUBMIT_APP_ASSESSMENT_ANSWER_MEDIA,
      set_assessment_average_time: ASSESSMENT_AVERAGE_TIME_STATS,
      update_assessment_cancelled: APP_AI_ASSESSMENT_CANCELLED
    }),
    ...mapActions("recruiter", {
      fetch_ai_assessment_details: FETCH_APPLICANT_ASSESSMENT_DETAILS
    }),
    ...mapActions("common", {
      upload_file_chunk: UPLOAD_FILE_CHUNK,
      mark_assessment_resumed: MARK_ASSESSMENT_RESUMED,
      save_assessment_state: SAVE_ASSESSMENT_STATE
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async fetchAiAssessmentData(this: any) {
      try {
        const assessmentId = this.$route.params.id;
        const applicantId = this.get_user?.id;

        if (!assessmentId || !applicantId) {
          this.set_root_error(
            this.$t("ai-assessments.errors.no-id").toString()
          );
          return;
        }
        const success = await this.fetch_ai_assessment_details({
          applicant_id: applicantId.toString(),
          assessment_id: assessmentId.toString()
        });

        if (!success) {
          this.set_root_error(
            this.$t("ai-assessments.errors.load-failed").toString()
          );
          return;
        }

        // Transform the API data to match the expected format
        const assessmentData = this.ai_assessment_details;

        if (
          assessmentData &&
          assessmentData.questions &&
          assessmentData.questions.length > 0
        ) {
          // Convert questions to the format expected by the component
          const transformedQuestions = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            filter: "mcqs", // Default to MCQs for AI assessment
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            mcqs: assessmentData.questions.map((question: any) => ({
              id: question.id,
              assessment_id: question.assessment_id,
              question_text: question.question_text,
              question_type: question.question_type,
              question_options: question.question_options,
              question_time_allowed: question.question_time_allowed,
              is_question_enable: question.is_question_enable,
              created_by: question.created_by,
              user_id: question.user_id,
              job_id: question.job_id,
              is_completed: question.is_completed,
              answer: question.answer
            })),
            speaking: [],
            written: [],
            mcqs_completed: false,
            current_question_index: 0
          };

          // Set the assessment data in the store
          this.set_app_ai_assessments(transformedQuestions);
        } else {
          console.error("No valid assessment data received:", assessmentData);
          this.set_root_error(
            this.$t("ai-assessments.errors.no-questions").toString()
          );
        }
      } catch (error) {
        console.error("Error fetching AI assessment data:", error);
        this.set_root_error(
          this.$t("ai-assessments.errors.load-error").toString()
        );
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async check_stage(this: any) {
      const stage = localStorage.getItem("stage");
      if (stage && stage !== ViewAssessmentsOptions.SPEAKING) {
        this.set_app_ai_assessments({
          filter: stage,
          speaking: this.app_ai_assessment.speaking,
          mcqs: this.app_ai_assessment?.mcqs,
          written: this.app_ai_assessment.written
        });
        if (stage === ViewAssessmentsOptions.MCQS.toLowerCase()) {
          const storedArray = JSON.parse(
            localStorage.getItem("answers") || "[]"
          );
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.options = storedArray.map((item: any) =>
            item === null ? undefined : item
          );
          // console.log("this.options1:", this.options);
          // this.options = storedArray;
        }
      } else {
        localStorage.setItem("stage", this.app_ai_assessment.filter);
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async process_ans(
      this: any,
      question_id: number,
      question_index: number,
      question_text: string,
      answer: string,
      correct_answer: string
    ) {
      this.submit_ans_loading = true;
      const current_result = answer === correct_answer ? true : false;
      this.options[question_index] = {
        question: question_text,
        question_index: question_index,
        answer: answer,
        result: current_result
      };

      const arrayFull = Array.from({
        length: this.app_ai_assessment?.mcqs?.length
      }).every((_, index) => this.options[index] !== undefined);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.answeredMcqsCount = this.options.filter(
        (item: any) => item !== undefined && item !== null
      )?.length;
      this.disabled_mcqs1_question =
        this.answeredMcqsCount == 10 ? false : true;
      const payload: UpdateAssessmentMcqsPayload = {
        filter: ViewAssessmentsOptions.MCQS,
        answer: answer,
        question_id: question_id
      };
      // Update localStorage with the new array
      localStorage.setItem(
        "stage",
        arrayFull
          ? ViewAssessmentsOptions.WRITING.toLowerCase()
          : payload.filter
      );
      localStorage.setItem(
        "question_id",
        !arrayFull ? payload.question_id.toString() : ""
      );

      !arrayFull
        ? localStorage.setItem("answers", JSON.stringify(this.options))
        : localStorage.setItem("answer", "");

      this.set_app_ai_assessments({
        filter: ViewAssessmentsOptions.MCQS,
        mcqs_completed: arrayFull,
        mcqs: this.app_ai_assessment?.mcqs,
        written: this.app_ai_assessment.written,
        current_question_index: question_index
      });

      // const success =
      this.update_app_ai_assessment_questions(payload); // Update current question answer in store
      const mcqs_api_payload: SubmitAssessmentMcqsAnswersApiPayload = {
        answer: answer,
        question_id: question_id,
        answer_type: this.app_ai_assessment?.mcqs[question_index].question_type,
        assessment_id:
          this.app_ai_assessment?.mcqs[question_index].assessment_id
      };
      const response = await this.submit_assessment_answers(mcqs_api_payload);

      this.set_assessment_average_time({
        answer_time: this.questionTime.toString()
      });
      this.questionTime = 0;
      this.startTimer("questionTime");
      if (!response) {
        this.set_root_error(`${this.$t("assessments.went-wrong")}`);
        this.submit_ans_loading = false;
        return;
      }

      this.submit_ans_loading = false;
      this.disabled_next_question = !arrayFull;
    },
    // startTimer(time: keyof Vue["$data"]) {
    //   setInterval(() => {
    //     (this as any)[time]++;
    //   }, 1000);
    // },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    startTimer(this: any, time: string) {
      // If a timer for this variable already exists, clear it first
      if (this.timers[time]) {
        clearInterval(this.timers[time]);
      }

      // Start a new interval and store the ID in the object
      this.timers[time] = setInterval(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[time]++;
      }, 1000);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    stopTimer(this: any, time: string) {
      if (this.timers[time]) {
        clearInterval(this.timers[time]);
        delete this.timers[time];
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    stop_recording(this: any) {
      this.recording = false;
      this.paused = false;
      this.totalPausedTime = 0;
      this.elapsedTime = "0:0";
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOffline() {
      if (!this.assessmentCompleted) {
        this.isOffline = true;
        this.set_root_error(
          this.$t("assessments.internet-disconnected").toString()
        );
      }
    },
    handleOnline() {
      this.isOffline = false;
    },
    handleVisibilityChange() {
      // When the tab is hidden (user switches tab or application) and this is not a hard reload,
      // stop allowing the candidate to continue this assessment session in the background.
      if (
        typeof document === "undefined" ||
        document.visibilityState !== "hidden" ||
        this.is_reload ||
        this.assessmentCompleted ||
        this.assessmentCancelled
      ) {
        return;
      }

      // Persist basic timing state so that any allowed resume flow can pick up correct timers
      try {
        localStorage.setItem("assessmentTime", this.assessmentTime.toString());
        localStorage.setItem(
          "aiAssessmentTimer",
          this.ai_assessment_timer.toString()
        );
        localStorage.setItem("partTime", this.partTime.toString());
        localStorage.setItem("questionTime", this.questionTime.toString());
        if (this.app_ai_assessment?.filter) {
          localStorage.setItem("stage", this.app_ai_assessment.filter);
        }
      } catch (e) {
        // ignore storage failures – navigation below still enforces the rule
      }

      // Stop all active media immediately so recording does not continue in background
      this.stopAllMediaStreams();

      // Surface a clear error so the candidate understands why they were exited
      this.set_root_error(
        "Your AI assessment session was closed because the browser tab was moved to the background."
      );

      // Navigate away from the assessment so it cannot continue in a hidden tab
      this.$router.push("/candidate/dashboard");
    },
    // Function to intiatia whole process
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async play_questionMedia(this: any, index: string) {
      this.canSelect = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const question: any = this.app_ai_assessment.speaking[index] || null;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const question_url: any = question
        ? question.question_options.question_voice_url
        : null;
      this.push_chat_history_obj(
        question.question_text,
        this.format_chat_date(),
        this.bot_image
      );
      await wait_until(1500);
      if (question.question_options && question_url) {
        await this.playAudio(question_url);
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async init_process(this: any) {
      this.loading = true;
      this.error = null;
      try {
        // If assessment is already submitted, mark completed and exit early
        const existingStatus = this.assessmentData?.results?.[0]?.status;
        const allCompleted = Array.isArray(this.assessmentData?.questions)
          ? (this.assessmentData?.questions || []).every(
              (q: any) => q.is_completed
            )
          : false;
        if (
          existingStatus === AssessmentResultStatus.COMPLETED ||
          existingStatus === AssessmentResultStatus.RESULT_PROCESSING ||
          allCompleted
        ) {
          this.assessmentCompleted = true;
          this.loading = false;
          return;
        }

        if (isIOS()) {
          this.error = this.$t("assessments.browser-unsupport").toString();
          this.loading = false;
          this.set_screen_recording_supported(false);
          return;
        }

        await this.invokeCamera(); // Ask for camera (video/audio) permission
        // If camera permission is not supported then stop the process
        if (this.error) {
          console.log(this.error);
          this.loading = false;
          return;
        }
        // If user didn't allow camera permission then stop the process
        if (
          !this.get_camera_recording_supported ||
          !this.camera_media_stream ||
          !this.audio_media_stream
        ) {
          this.loading = false;
          return;
        }
        this.camera_media_enabled = true; // Set camera enabled to true

        await this.invokeScreenRecording(); // Ask for screen recording permission
        // If screen recording permission not supported
        if (this.error) {
          this.loading = false;
          return;
        }
        // If user didn't allow screen recording permission then stop the process
        if (!this.media_stream) {
          this.loading = false;
          return;
        }
        this.media_enabled = true; // Set screen recording enabled to true
        this.loading = false;

        // At this point the assessment is truly started:
        // - user has accepted terms (handled by parent component)
        // - camera + microphone are granted
        // - screen sharing is granted
        // Mark assessment as IN_PROGRESS so resume workflow can apply.
        try {
          const assessmentId = Number(this.$route.params.id);
          if (assessmentId) {
            await this.mark_assessment_resumed(assessmentId);
            // Notify parent that the assessment has truly started (all permissions granted).
            // This lets the parent distinguish "left after starting" from "cancelled before starting".
            this.$emit("assessment_started");
          }
        } catch (_e) {
          // Non-blocking: even if this fails, candidate can still complete assessment.
        }
        let stage = localStorage.getItem("stage");

        // For AI assessments, we focus on MCQs and set the stage accordingly
        this.assessment_type = "ai_assessment";

        if (stage === null) {
          localStorage.setItem(
            "stage",
            ViewAssessmentsOptions.MCQS.toLowerCase()
          );
          stage = ViewAssessmentsOptions.MCQS.toLowerCase();
        }
        //timer procedure start
        //getprevious time of assessment
        const assessmentTime =
          Number(localStorage.getItem("assessmentTime")) || 0;
        if (assessmentTime > 0) {
          this.assessmentTime = assessmentTime;
          localStorage.removeItem("assessmentTime");
        }
        //getprevious time of part
        const partTime = Number(localStorage.getItem("partTime")) || 0;
        if (partTime > 0) {
          this.partTime = partTime;
          localStorage.removeItem("partTime");
        }

        //getprevious time of question
        const questionTime = Number(localStorage.getItem("questionTime")) || 0;
        if (questionTime > 0) {
          this.questionTime = questionTime;
          localStorage.removeItem("questionTime");
        }
        this.startTimer("assessmentTime");
        this.startTimer("partTime");
        this.startTimer("questionTime");
        //timer procedure end
        this.start_recording(); // Start recording for AI assessment
      } catch (error) {
        this.error = this.$t("assessments.unable-access").toString();
      }
    },
    // Function to invoke screen recording permission from user and start recording
    async invokeGetDisplayMedia() {
      // Check if browser supports screen recording
      if (navigator?.mediaDevices?.getDisplayMedia) {
        try {
          const displayOptions = {
            video: true,
            audio: true,
            ...(isSafari() && { preferCurrentTab: true })
          };
          this.media_stream = await navigator.mediaDevices.getDisplayMedia(
            displayOptions
          );
          if (!this.media_stream) return;
          // Detect when user revokes screen share in browser settings during assessment
          this.media_stream.getTracks().forEach((track) => {
            track.addEventListener("ended", this.handleScreenShareRevoked);
          });
          this.screen_recorder = new MediaRecorder(this.media_stream); // Create a media recorder
          this.screen_recorder.start(15000); // Start recording
          this.screen_recroding_start_time = new Date(); // Set camera recording start time
          // ondataavailable event will be triggered when there is data available
          this.screen_recorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.screen_recoding_chunks.push(event.data);
            }
            if (
              !this.assessment_cancelled &&
              !this.assessment_completed &&
              this.screen_recorder?.state !== "recording"
            ) {
              this.set_root_error(`${this.$t("assessments.share-screen")}`);
              this.invokeGetDisplayMedia();
              return;
            }
            if (
              this.screen_recoding_chunks.reduce(
                (sum, chunk) => sum + chunk.size,
                0
              ) >= this.screen_recording_upload_chuk_size
            ) {
              this.upload_recording_chunks(AssessmentRecordType.SCREEN);
            }
          };
          // onstop event will be triggered when user stops recording
          this.screen_recorder.onstop = () => {
            if (this.screen_recorder) {
              this.screen_recorder.stream
                .getTracks()
                .forEach((track) => track.stop());
              this.screen_recorder.ondataavailable = null;
              this.screen_recorder.onstop = null;
              this.screen_recorder = null;
              this.media_stream = null;
              this.screen_recroding_end_time = new Date(); // Set camera recording end time
            }
          };
          this.set_screen_recording_supported(true);
        } catch (error) {
          this.media_enabled = false;
          this.media_stream = null;
          this.screen_recorder = null;
        }
      } else {
        this.error = this.$t("assessments.browser-unsupport").toString();
        this.media_enabled = false;
        this.media_stream = null;
        this.screen_recorder = null;
        this.set_screen_recording_supported(false);
        this.loading = false;
      }
    },
    async invokeCamera() {
      if (!navigator?.mediaDevices?.getUserMedia) {
        this.error = this.$t("assessments.browser-unsupport-camera").toString();
        this.camera_media_stream = null;
        this.audio_media_stream = null;
        this.speech_recognition = null;
        this.camera_media_recorder = null;
        this.loading = false;
        this.set_camera_recording_supported(false);
        return;
      }

      try {
        const userMediaConstraints = {
          video: isSafari() ? { facingMode: "user" } : true,
          audio: true
        };
        const stream = await navigator.mediaDevices.getUserMedia(
          userMediaConstraints
        );

        if (stream && stream.getTracks().length > 0) {
          this.camera_media_stream = stream;
          this.audio_media_stream = stream;

          // Configure optional features safely
          if (
            "webkitSpeechRecognition" in window ||
            "SpeechRecognition" in window
          ) {
            await this.config_speech_recognition();
          }

          await this.config_video_recording(stream);
          this.set_camera_recording_supported(true);
          // Detect when user revokes camera or mic in browser settings (handle separately)
          stream.getTracks().forEach((track) => {
            track.addEventListener("ended", () =>
              this.handleCameraOrMicRevoked(track)
            );
          });
        } else {
          throw new Error("No active tracks found in stream");
        }
      } catch (e) {
        console.error("Camera initialization failed:", e);
        const err = e as { name?: string } | null;
        this.camera_media_stream = null;
        this.audio_media_stream = null;
        this.speech_recognition = null;
        this.camera_media_recorder = null;
        if (
          err?.name === "NotFoundError" ||
          err?.name === "DevicesNotFoundError"
        ) {
          this.error = this.$t("assessments.no-camera-device").toString();
        } else {
          this.error = this.$t("assessments.permission-denied").toString();
        }
        this.set_camera_recording_supported(false);
      }
    },
    async invokeScreenRecording() {
      if (navigator?.mediaDevices?.getDisplayMedia) {
        try {
          const displayOptions = {
            video: true,
            audio: true,
            ...(isSafari() && { preferCurrentTab: true })
          };
          this.media_stream = await navigator.mediaDevices.getDisplayMedia(
            displayOptions
          );
          this.set_screen_recording_supported(true);
        } catch (error: unknown) {
          this.set_screen_recording_supported(false);
          if ((error as Error).name === "NotAllowedError") {
            this.error = this.$t(
              "assessments.screen-permission-denied"
            ).toString();
          } else if ((error as Error).name === "NotFoundError") {
            this.error = this.$t("assessments.screen-not-found").toString();
          } else {
            this.error = this.$t("assessments.screen-error").toString();
          }
        }
      } else {
        this.error = this.$t("assessments.browser-unsupport").toString();
        this.set_screen_recording_supported(false);
        this.loading = false;
      }
    },
    async config_speech_recognition() {
      try {
        const speech_recognition = window.webkitSpeechRecognition;
        this.speech_recognition = new speech_recognition();
        this.speech_recognition.interimResults = true;
        this.speech_recognition.continuous = true;
        this.speech_recognition.onresult = this.handle_user_speech;
      } catch (e) {
        throw this.$t("assessments.no-speech-recognition");
      }
    },
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handle_user_speech(result: any) {
      this.transcript = Array.from(result.results || [])
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map((speechResultItem: any) => {
          if (speechResultItem.isFinal)
            return speechResultItem[0]?.transcript || "";
          return "";
        })
        .join("");
    },
    async config_video_recording(stream: MediaStream) {
      try {
        const mimeTypes = getMediaRecorderMimeTypes();
        let options: { mimeType?: string } = {};
        for (const mimeType of mimeTypes) {
          if (MediaRecorder.isTypeSupported(mimeType)) {
            options = { mimeType };
            break;
          }
        }
        this.camera_media_recorder = new MediaRecorder(stream, options);
        this.camera_media_recorder.start(15000);
        this.camera_recording_start_time = new Date();
        const video = this.$refs.camera as HTMLVideoElement;
        video.srcObject = stream;
        this.camera_media_recorder.ondataavailable = this.media_recorder_data;
        this.camera_media_recorder.onstop = this.handle_media_recorder_stop;
        if (this.audio_media_stream)
          this.set_audio_recorder(this.audio_media_stream);
      } catch (e) {
        throw this.$t("assessments.unable-record");
      }
    },
    handleCameraOrMicRevoked(track: MediaStreamTrack) {
      if (
        this.media_stopped ||
        this.assessment_completed ||
        this.assessment_cancelled
      )
        return;

      const stream = this.camera_media_stream;
      const videoLive =
        stream?.getVideoTracks().some((t) => t.readyState === "live") ?? false;
      const audioLive =
        stream?.getAudioTracks().some((t) => t.readyState === "live") ?? false;

      const msgCamera = this.$t(
        "assessments.permission-revoked-camera"
      ).toString();
      const msgMic = this.$t("assessments.permission-revoked-mic").toString();
      const msgBoth = this.$t("assessments.permission-revoked").toString();

      // Some browsers end both tracks when only one permission is revoked.
      // Prefer a precise message when we can, otherwise fall back to "camera or mic".
      let msg = msgBoth;
      if (track.kind === "audio") {
        msg = videoLive ? msgMic : msgBoth;
      } else if (track.kind === "video") {
        msg = audioLive ? msgCamera : msgBoth;
      }

      this.error = msg;
      this.set_root_error(msg);
      if (track.kind === "video" || !videoLive) {
        this.set_camera_recording_supported(false);
      }
    },
    handleScreenShareRevoked() {
      if (!this.assessment_completed && !this.assessment_cancelled) {
        const msg = this.$t("assessments.permission-revoked").toString();
        this.error = msg;
        this.set_root_error(msg);
        this.set_screen_recording_supported(false);
      }
    },
    handle_media_recorder_stop() {
      if (this.camera_media_recorder) {
        this.camera_media_recorder.stream
          .getTracks()
          .forEach((track) => track.stop());
        this.camera_media_recorder.ondataavailable = null;
        this.camera_media_recorder.onstop = null;
        this.camera_media_recorder = null;
        this.camera_media_stream = null;
        this.audio_media_stream = null;
        this.media_stopped = true;
        this.camera_recording_end_time = new Date();
        if (
          this.get_screen_recording_supported &&
          this.get_camera_recording_supported &&
          this.assessment_completed
        )
          this.process_assessment_completed();
      }
    },
    stopAllMediaStreams() {
      try {
        // --- Release camera preview first so "camera in use" indicator goes off immediately ---
        const cameraEl = this.$refs.camera as HTMLVideoElement | undefined;
        if (cameraEl && cameraEl.srcObject) {
          const stream = cameraEl.srcObject as MediaStream;
          try {
            stream.getTracks().forEach((t) => t.stop());
          } catch (e) {
            // ignore
          }
          cameraEl.srcObject = null;
          cameraEl.load();
        }

        // --- Stop speech recognition ---
        if (this.speech_recognition) {
          try {
            this.speech_recognition.stop();
          } catch (e) {
            // ignore
          }
          this.speech_recognition = null;
        }

        // --- Stop and clear screen recorder + stream ---
        if (this.screen_recorder) {
          try {
            this.screen_recorder.stop();
          } catch (e) {
            // ignore
          }

          if (this.screen_recorder.stream) {
            try {
              this.screen_recorder.stream.getTracks().forEach((t) => t.stop());
            } catch (e) {
              // ignore
            }
          }

          this.screen_recorder.ondataavailable = null;
          this.screen_recorder.onstop = null;
          this.screen_recorder = null;
          this.media_stream = null;
          this.screen_recording_end_time = new Date();
        }

        // --- If there is an active screen-share stream without a recorder, stop it too ---
        if (this.media_stream) {
          try {
            this.media_stream.getTracks().forEach((t) => t.stop());
          } catch (e) {
            // ignore
          }
          this.media_stream = null;
        }

        // --- Stop and clear camera recorder + stream ---
        if (this.camera_media_recorder) {
          try {
            this.camera_media_recorder.stop();
          } catch (e) {
            // ignore
          }

          if (this.camera_media_recorder.stream) {
            try {
              this.camera_media_recorder.stream
                .getTracks()
                .forEach((t) => t.stop());
            } catch (e) {
              // ignore
            }
          }

          this.camera_media_recorder.ondataavailable = null;
          this.camera_media_recorder.onstop = null;
          this.camera_media_recorder = null;
        }

        // --- Stop and clear camera media stream ---
        if (this.camera_media_stream) {
          try {
            this.camera_media_stream.getTracks().forEach((t) => t.stop());
          } catch (e) {
            // ignore
          }
          this.camera_media_stream = null;
          this.camera_recording_end_time = new Date();
        }

        // --- Stop and clear audio stream ---
        if (this.audio_media_stream) {
          try {
            this.audio_media_stream.getTracks().forEach((t) => t.stop());
          } catch (e) {
            // ignore
          }
          this.audio_media_stream = null;
        }

        // --- Extra: Stop and clear any <video> or <audio> elements still using live streams ---
        document.querySelectorAll("video, audio").forEach((el) => {
          if (el.srcObject) {
            try {
              el.srcObject.getTracks().forEach((t) => t.stop());
            } catch (e) {
              // ignore
            }
            el.srcObject = null;
          }
        });

        // --- Mark everything as stopped ---
        this.media_stopped = true;

        // Optional: small delay to ensure hardware is released (browser quirk)
        setTimeout(() => {
          console.log("✅ All media streams stopped and cleaned up");
        }, 300);
      } catch (e) {
        console.error("stopAllMediaStreams error:", e);
      }
    },

    async media_recorder_data(data: BlobEvent) {
      if (data.data && data.data.size > 0) {
        this.camera_recorded_blobs.push(data.data);
      }
      if (
        this.camera_recorded_blobs.reduce(
          (sum, chunk) => sum + chunk.size,
          0
        ) >= this.camera_recording_upload_chuk_size
      ) {
        this.upload_recording_chunks(AssessmentRecordType.CAMERA);
      }
    },
    speak_config() {
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      if (userAudioElement) {
        userAudioElement.load();
        userAudioElement.pause();
      }
      if (this.speech_mode) {
        this.speech_mode = false;
        wait_until(1000);
        this.speech_recognition.stop();
        this.audio_recorder?.pause();
        if (this.audio_media_stream) {
          const audioTrack = this.audio_media_stream.getAudioTracks()[0];
          if (audioTrack) {
            audioTrack.enabled = false;
          }
        }
        this.pauseRecording();
      } else {
        this.speech_mode = true;
        this.transcript = "";
        this.speech_recognition.start();
        if (this.audio_recorder && this.audio_recorder.state === "inactive") {
          this.start_recording();
          this.audio_recorder.start(100);
        } else {
          if (this.audio_recorder) {
            this.audio_recorder.resume();
            this.resumeRecording();
          }
        }
        if (this.audio_media_stream) {
          const audioTrack = this.audio_media_stream.getAudioTracks()[0];
          if (audioTrack) {
            audioTrack.enabled = true;
          }
        }
      }
    },
    format_chat_date(date: number = moment.now()): string {
      return moment(date).format("ddd, h:mm A").toString();
    },
    push_chat_history_obj(
      content: string,
      created_at: string,
      picture: string,
      role: AssessmentChatRoles = AssessmentChatRoles.BOT,
      id: number = generate_random_key(),
      audio_url?: string | null,
      time = ""
    ) {
      this.speaking_history.push({
        content,
        role,
        picture,
        created_at,
        id,
        audio_url,
        time
      });
    },
    async playAudio(file: string) {
      this.ttsAudio = new Audio(file);
      const video: HTMLVideoElement = this.$refs.video as HTMLVideoElement;
      video.muted = true;
      video.loop = true;
      await video.play();
      await this.ttsAudio.play();
      // if (this.canSelect === false) {
      //   await this.clear_audio_rec();
      // }
      this.ttsAudio.onended = async () => {
        this.bot_speaking = false;
        video.pause();
        video.currentTime = 0;
        this.transcript = "";
        // this.speak_config();
      };
      // this.update(video);
    },
    // Function to get text field message based on  bot speaking
    text_field_msg() {
      if (this.bot_speaking) {
        return this.$t("candidate.interview.speak").toString();
      } else return this.$t("candidate.interview.listening").toString();
    },
    complete_mcqs_part1() {
      this.mcqs_part1_completed = true;
    },
    send_mcqs_response() {
      this.set_app_ai_assessments({
        filter: ViewAssessmentsOptions.WRITING.toLowerCase(),
        mcqs_completed: true,
        mcqs: this.app_ai_assessment?.mcqs,
        written: this.app_ai_assessment.written
      });
      this.set_assessment_average_time({
        mcqs_time: this.partTime.toString()
      });
      this.questionTime = 0;
      this.partTime = 0;
      this.startTimer("partTime");
      this.startTimer("questionTime");
    },
    // Function to send user response to server and process next question
    async send_user_response() {
      this.submit_ans_loading = true;
      this.audio_recorder?.stop();
      // If user is speaking then stop speech recognition
      if (this.speech_mode) {
        this.speech_mode = false; // Set speech mode to false
        this.speech_recognition.stop(); // Stop speech recognition
        this.audio_recorder?.stop();
        this.construct_audio_url();
      }
      this.bot_speaking = true; // Set bot speaking to true
      this.bot_ans_loading = true; // Set bot answering to true
      const answer = this.transcript; // Get user answer
      this.push_chat_history_obj(
        answer,
        this.format_chat_date(),
        this.get_user.avatar_uri,
        AssessmentChatRoles.USER,
        generate_random_key(),
        this.individual_ans_blob
          ? URL.createObjectURL(this.individual_ans_blob)
          : null,
        this.elapsedTime
      );
      this.stopRecording();
      await this.update_chat_cursor(); // Update cursor of chat box
      // Update current question answer in store
      const payload: UpdateAssessmentQuestionPayload = {
        filter: this.app_ai_assessment.filter,
        answer: this.transcript,
        question_id:
          this.app_ai_assessment.speaking[this.current_question_index].id
      };
      this.update_app_ai_assessment_questions(payload); // Update current question answer in store

      localStorage.setItem(
        "stage",
        this.assessment_type === "ai_v3"
          ? ViewAssessmentsOptions.MCQS.toLowerCase()
          : payload.filter
      );
      localStorage.setItem("question_id", payload.question_id.toString());
      // Api Call to save current question answer
      const api_payload: SubmitAssessmentAnswersApiPayload = {
        answer: this.transcript,
        question_id:
          this.app_ai_assessment.speaking[this.current_question_index].id,
        answer_type:
          this.app_ai_assessment.speaking[this.current_question_index]
            .question_type,
        assessment_id:
          this.app_ai_assessment.speaking[this.current_question_index]
            .assessment_id
      };
      const response = await this.submit_assessment_answers(api_payload);
      if (!response) {
        this.set_root_error(`${this.$t("assessments.went-wrong")}`);
        this.submit_ans_loading = false;
        return;
      }
      const blob = this.individual_ans_blob;
      if (this.assessment_type !== "ai_v3") {
        this.increment_question_index(this.current_question_index + 1); // Increment current question
        await this.process_question(); // Process next question from bot or enable written assessment if all questions are answered;
      } else {
        const msqsCompleted =
          this.app_ai_assessment.mcqs?.length < 1 ? true : false;
        const filter = msqsCompleted
          ? ViewAssessmentsOptions.WRITING.toLowerCase()
          : ViewAssessmentsOptions.MCQS.toLowerCase();
        this.set_app_ai_assessments({
          filter: filter,
          speaking_completed: true,
          msqsCompleted: msqsCompleted,
          speaking: this.app_ai_assessment.speaking,
          mcqs: this.app_ai_assessment?.mcqs,
          written: this.app_ai_assessment.written
        });
      }
      this.user_ans_recorder_chunks = []; // Reset user answer recording chunks
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      userAudioElement.src = ""; // Reset user audio element
      this.individual_ans_blob = null; // Reset individual answer blob
      this.submit_ans_loading = false; // Set submit answer loading to false
      const ans_id = response.id;
      if (ans_id && blob) {
        const formData = new FormData();
        formData.append(
          "audio",
          blob,
          `${this.app_ai_assessment.speaking[0].assessment_id}_ans_${ans_id}.wav`
        );
        formData.append("answer_id", ans_id.toString());
        formData.append(
          "assessment_id",
          this.app_ai_assessment.speaking[0].assessment_id
        );
        await this.submit_assessment_ans_media(formData);
      }
    },
    // Function to process next question from bot or enable written assessment
    // if all questions are answered
    // else increment current question and process next question
    async process_question() {
      // If all questions are not answered then process next question
      if (
        this.current_question_index <=
        this.app_ai_assessment.speaking?.length - 1
      ) {
        // Get question
        const question =
          this.app_ai_assessment.speaking[this.current_question_index];
        // Push question in chat history
        this.push_chat_history_obj(
          question.question_text,
          this.format_chat_date(),
          this.bot_image
        );
        await this.update_chat_cursor(); // Update cursor of chat box
        this.bot_ans_loading = false; // Set bot answering to false
        this.transcript = ""; // Reset user answer
        // Play audio of question if available
        if (
          question.question_options &&
          question.question_options.question_voice_url
        ) {
          await this.playAudio(question.question_options.question_voice_url);
        }
      } else {
        // console.log("LAst question: ", this.app_ai_assessment.mcqs);
        const msqsCompleted =
          this.app_ai_assessment?.mcqs?.length < 1 ? true : false;
        const filter = msqsCompleted
          ? ViewAssessmentsOptions.WRITING.toLowerCase()
          : ViewAssessmentsOptions.MCQS.toLowerCase();
        this.set_app_ai_assessments({
          filter: filter,
          speaking_completed: true,
          msqsCompleted: msqsCompleted,
          speaking: this.app_ai_assessment.speaking,
          mcqs: this.app_ai_assessment?.mcqs,
          written: this.app_ai_assessment.written
        });
      }
    },
    // Function to update chat box cursor to bottom
    async update_chat_cursor() {
      await wait_until(1000); // Wait for 1 second
      const box = this.$refs.chat_box as HTMLDivElement; // Get chat box
      if (box) box.scrollTop = box.scrollHeight; // Set scroll top to scroll height
    },
    // Set Title When Site Direction Change
    camera_enable_title() {
      return this.$t(
        "candidate.interview.permission.declined-title"
      ).toString();
    },
    screen_enable_title() {
      return this.$t(
        "candidate.interview.permission.declined-title1"
      ).toString();
    },
    async process_reshare_screen() {
      await this.invokeGetDisplayMedia();
      if (this.media_stream) {
        this.media_enabled = true;
        this.error = "";
      }
    },
    async uploadFileWithChunks(file: File, filename: string) {
      this.media_uploading = true; // Set media uploading to true
      let retry = 0;
      const chunkSize = 2 * 1024 * 1024; // 2MB chunk size
      let start = 0;
      // Loop until start is less than file size
      while (start < file.size) {
        let end = Math.min(start + chunkSize, file.size); // Get end index
        let chunk = file.slice(start, end); // Get chunk
        const formData = new FormData(); // Create a form data
        formData.append("file", chunk, filename); // Append chunk to form data
        // formData.append("start", start.toString()); // Append start index to form data
        formData.append("filename", filename); // Append file name to form data
        const response = await this.upload_file_chunk(formData); // Api call to upload file chunk
        if (response && retry < 15) {
          start = end; // If response exist then set start to end
          retry = 0;
          this.media_uploading_progress = Math.round((start / file.size) * 100); // Set media uploading progress
        } else if (retry >= 15) {
          this.set_root_error(`${this.$t("assessments.upload-file-error")}`);
          break;
        } else {
          retry += 1;
        }
      }
      this.media_uploading = false; // Set media uploading to false
      this.media_uploading_progress = 0; // Set media uploading progress to 0
      this.media_uploading_title = ""; // Set media uploading title to empty
    },
    construct_audio_url() {
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      try {
        if (this.user_ans_recorder_chunks?.length > 0 && userAudioElement) {
          this.individual_ans_blob = new Blob(this.user_ans_recorder_chunks, {
            type: "audio/wav"
          });
          const audioUrl = URL.createObjectURL(this.individual_ans_blob);
          userAudioElement.src = audioUrl;
          userAudioElement.load();
          // userAudioElement.play();
        }
      } catch (e) {
        // console.log(e, "e");
      }
    },
    set_audio_recorder(stream: MediaStream) {
      const audioTrack = stream.getAudioTracks()[0];
      this.audio_recorder = new MediaRecorder(new MediaStream([audioTrack]));
      this.user_ans_recorder_chunks = [];
      this.audio_recorder.ondataavailable = (event) => {
        if (audioTrack.enabled && event.data.size > 0) {
          this.user_ans_recorder_chunks.push(event.data);
          this.audio_recorder_chunks.push(event.data);
        }
      };
      this.audio_recorder.pause = () => {
        this.construct_audio_url();
      };
    },
    async clear_audio_rec() {
      // Get the parent element
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      if (userAudioElement) {
        this.audio_recorder?.stop();
        this.speech_recognition?.stop();
        this.audio_recorder = null;
        await wait_until(1000); // its important to wait for 1 second after clearing and audio recorder for process
        if (this.audio_media_stream) {
          this.set_audio_recorder(this.audio_media_stream); // Again intialized audio recorder
        }
        userAudioElement.src = "";
        this.individual_ans_blob = null;
        this.transcript = "";
        this.speech_mode = false;
        this.stopRecording();
      }
    },
    async upload_recording_chunks(type: AssessmentRecordType) {
      // For AI assessments, get the assessment_id from MCQs or route params
      let assessment_id;
      if (
        this.app_ai_assessment?.mcqs &&
        this.app_ai_assessment.mcqs?.length > 0
      ) {
        assessment_id = this.app_ai_assessment.mcqs[0].assessment_id;
      } else if (this.$route.params.id) {
        assessment_id = this.$route.params.id;
      } else {
        console.error("No assessment_id found for uploading recording chunks");
        return;
      }
      const { mimeType, extension } = getRecordingMimeTypeAndExt();
      const file_name = `assessment_${assessment_id}_user_${this.get_user.id}_${type}_recording.${extension}`;
      const blob_pick =
        type === AssessmentRecordType.SCREEN
          ? this.screen_recoding_chunks
          : this.camera_recorded_blobs;
      const fixedBlob = new Blob(blob_pick, { type: mimeType });
      // Clear blobs
      if (type === AssessmentRecordType.SCREEN) {
        this.screen_recoding_chunks = [];
      } else if (type === AssessmentRecordType.CAMERA) {
        this.camera_recorded_blobs = [];
      }
      const arrayBuffer = await fixedBlob.arrayBuffer();
      const buffer = Buffer.from(arrayBuffer);
      const bucket_prefix =
        this.get_company_details?.storage_path?.assessments_path
          ?.split("/")
          .slice(1)
          .join("/") ?? "open/assessments/inception";
      socketService.socket.emit("media-recorder-recording", {
        recording: buffer,
        user_id: this.get_user.id,
        file_name: file_name,
        completed: this.assessment_completed,
        cancelled: this.assessment_cancelled,
        assessment_id: assessment_id,
        assessment_type:
          this.get_company_details?.storage_path?.assessment_setting
            ?.candidates_ai ?? "unknown",
        bucket_prefix,
        recording_type: type
      });
    },
    start_recording() {
      this.startTime = Date.now();
      this.recording = true;
      this.updateTime();
    },
    stopRecording() {
      if (this.recording) {
        this.recording = false;
        this.paused = false;
        this.totalPausedTime = 0;
        this.elapsedTime = "0:0";
      }
    },
    pauseRecording() {
      if (!this.paused) {
        this.paused = true;
        this.pauseStartTime = Date.now();
      }
    },
    resumeRecording() {
      if (this.paused) {
        this.totalPausedTime += Date.now() - this.pauseStartTime;
        this.paused = false;
        this.startTime += Date.now() - this.pauseStartTime;
        this.updateTime();
      }
    },
    updateTime() {
      if (this.recording && !this.paused) {
        const currentTime = Date.now();
        const elapsedTime = Math.floor((currentTime - this.startTime) / 1000);
        const minutes = Math.floor(elapsedTime / 60);
        const seconds = elapsedTime % 60;
        this.elapsedTime = minutes + ":" + seconds;
        if (this.recording) {
          setTimeout(this.updateTime, 1000); // Update time every second
        }
      }
    }
  },
  watch: {
    assessmentCompleted(newVal: boolean) {
      if (newVal) {
        // Inform parent route so it can stop any background capture
        // (e.g. Additional Assessments screenshot loop) and update its UI.
        this.$emit("assessment_completed");
        if (this.assessmentCancelled) {
          this.$emit("assessment_cancelled");
        }

        this.stopTimer("ai_assessment_timer");
        this.stopTimer("part_timer");
        this.stopTimer("question_timer");
        this.stop_recording();
        // ensure all media is stopped
        this.stopAllMediaStreams();
        if (this.ttsAudio) this.ttsAudio.pause(); // Pause audio
        // Notify and navigate to candidate AI assessments list
        this.set_root_notification(
          this.assessmentCancelled
            ? this.$t("assessments.cancelled-successfully").toString()
            : this.$t("assessments.submitted-successfully").toString()
        );
        // Mark that we just submitted so dashboard shows "Submitted" when user visits it
        if (
          !this.assessmentCancelled &&
          typeof sessionStorage !== "undefined"
        ) {
          sessionStorage.setItem("ai_assessment_just_submitted", "1");
          sessionStorage.setItem(
            "ai_assessment_just_submitted_ts",
            String(Date.now())
          );
        }
        this.$router.push("/candidate/ai-assessments");
      }
    },
    // When user logs out during the assessment (auth store user cleared),
    // immediately stop all media and redirect straight to the login screen
    // without asking for any new camera/microphone/screen permissions.
    get_user(newVal: any) {
      if (!newVal) {
        try {
          this.stopAllMediaStreams();
        } catch (e) {
          // ignore
        }
        this.$router.push("/auth/login");
      }
    },
    deep: true,
    immediate: true
  },
  beforeDestroy() {
    window.removeEventListener("offline", this.handleOffline);
    window.removeEventListener("online", this.handleOnline);
    if (this.connectionCheckIntervalId != null) {
      clearInterval(this.connectionCheckIntervalId);
      this.connectionCheckIntervalId = null;
    }
    this.stopTimer("ai_assessment_timer");
    this.stopTimer("part_timer");
    this.stopTimer("question_timer");
    this.stop_recording();
    // console.log("Destroying:", this.screen_recorder);
    this.stopAllMediaStreams();
    if (this.ttsAudio) this.ttsAudio.pause(); // Pause audio
    // document.removeEventListener(
    //   "visibilitychange",
    //   this.handleVisibilityChange
    // );
  }
});
